export const emailArray = ["herz", "@", "med.nagoya-cu.ac.jp"];
export const hotLineEmailArray = ["ncucvs758", "@", "gmail.com"];
